export const firstColumnCategories = {
    columnTitle: 'Passion',
    links: [
        {
            name: 'Gaming',
            url: '/posters/gaming',
            image: 'https://displate.com/img/menu_static/categories/gaming.png',
        },
        {
            name: 'Sport',
            url: '/posters/sports',
            image: 'https://displate.com/img/menu_static/categories/sport.png',
        },
        {
            name: 'Anime & Manga',
            url: '/posters/anime',
            image: 'https://displate.com/img/menu_static/categories/anime-and-manga.png',
        },
        {
            name: 'Space',
            url: '/posters/space',
            image: 'https://displate.com/img/menu_static/categories/space.png',
        },
        {
            name: 'Cars',
            url: '/posters/cars',
            image: 'https://displate.com/img/menu_static/categories/cars.png',
        },
        {
            name: 'Fantasy',
            url: '/posters/fantasy',
            image: 'https://displate.com/img/menu_static/categories/fantasy.png',
        },
        {
            name: 'Japanese & Asian',
            url: '/posters/japanese',
            image: 'https://displate.com/img/menu_static/categories/japanese-and-asian.png',
        },
        {
            name: 'Military',
            url: '/posters/military',
            image: 'https://displate.com/img/menu_static/categories/military.png',
        },
        {
            name: 'Planes',
            url: '/posters/airplane',
            image: 'https://displate.com/img/menu_static/categories/planes.png',
        },
        {
            name: 'Fashion',
            url: '/posters/fashion',
            image: 'https://displate.com/img/menu_static/categories/fashion.png',
        },
    ],
};
export const secondColumnCategories = {
    columnTitle: 'Nature & Travel',
    links: [
        {
            name: 'Maps',
            url: '/posters/map',
            image: 'https://displate.com/img/menu_static/categories/maps.png',
        },
        {
            name: 'Animals',
            url: '/posters/animals',
            image: 'https://displate.com/img/menu_static/categories/animals.png',
        },
        {
            name: 'Nature',
            url: '/posters/nature',
            image: 'https://displate.com/img/menu_static/categories/nature.png',
        },
        {
            name: 'Cityscapes',
            url: '/posters/cityscapes',
            image: 'https://displate.com/img/menu_static/categories/cityscapes.png',
        },
        {
            name: 'Landscapes',
            url: '/posters/landscapes',
            image: 'https://displate.com/img/menu_static/categories/landscapes.png',
        },
        {
            name: 'Travel',
            url: '/posters/travel',
            image: 'https://displate.com/img/menu_static/categories/travel.png',
        },
        {
            name: 'Floral',
            url: '/posters/floral',
            image: 'https://displate.com/img/menu_static/categories/floral.png',
        },
    ],
};
export const thirdColumnCategories = {
    columnTitle: 'Culture',
    links: [
        {
            name: 'Movies',
            url: '/posters/movies',
            image: 'https://displate.com/img/menu_static/categories/movies.png',
        },
        {
            name: 'Music',
            url: '/posters/music',
            image: 'https://displate.com/img/menu_static/categories/music.png',
        },
        {
            name: 'Retro',
            url: '/posters/retro',
            image: 'https://displate.com/img/menu_static/categories/retro.png',
        },
        {
            name: 'Funny',
            url: '/posters/funny',
            image: 'https://displate.com/img/menu_static/categories/funny.png',
        },
        {
            name: 'Comics',
            url: '/posters/comics',
            image: 'https://displate.com/img/menu_static/categories/comics.png',
        },
        {
            name: 'Tv Shows',
            url: '/posters/tv-shows',
            image: 'https://displate.com/img/menu_static/categories/tv-shows.png',
        },
        {
            name: 'Cartoons',
            url: '/posters/cartoons',
            image: 'https://displate.com/img/menu_static/categories/cartoons.png',
        },
        {
            name: 'Celebrities',
            url: '/posters/celebrity',
            image: 'https://displate.com/img/menu_static/categories/celebrities.png',
        },
        {
            name: 'Books',
            url: '/posters/book',
            image: 'https://displate.com/img/menu_static/categories/books.png',
        },
        {
            name: 'Cute',
            url: '/posters/cute',
            image: 'https://displate.com/img/menu_static/categories/cute.png',
        },
    ],
};
export const fourthColumnCategories = {
    columnTitle: 'Interior Design',
    links: [
        {
            name: 'Inspirational',
            url: '/posters/motivational',
            image: 'https://displate.com/img/menu_static/categories/inspirational.png',
        },
        {
            name: 'Vintage posters',
            url: '/posters/vintage',
            image: 'https://displate.com/img/menu_static/categories/vintage-posters.png',
        },
        {
            name: 'Minimalistic',
            url: '/posters/minimalist',
            image: 'https://displate.com/img/menu_static/categories/minimalistic.png',
        },
        {
            name: 'Pop art',
            url: '/posters/pop-art',
            image: 'https://displate.com/img/menu_static/categories/pop-art.png',
        },
        {
            name: 'Text art',
            url: '/posters/text-art',
            image: 'https://displate.com/img/menu_static/categories/text-art.png',
        },
        {
            name: 'Abstract',
            url: '/posters/abstract',
            image: 'https://displate.com/img/menu_static/categories/abstract.png',
        },
        {
            name: 'Paintings',
            url: '/posters/paintings',
            image: 'https://displate.com/img/menu_static/categories/paintings.png',
        },
        {
            name: 'Food & Kitchen',
            url: '/posters/food',
            image: 'https://displate.com/img/menu_static/categories/food-and-kitchen.png',
        },
        {
            name: 'Mancave',
            url: '/posters/mancave',
            image: 'https://displate.com/img/menu_static/categories/mancave.png',
        },
        {
            name: 'Contemporary art',
            url: '/posters/contemporary-art',
            image: 'https://displate.com/img/menu_static/categories/contemporary-art.png',
        },
        {
            name: 'Blueprints',
            url: '/posters/blueprint',
            image: 'https://displate.com/img/menu_static/categories/blueprints.png',
        },
    ],
};
//# sourceMappingURL=categoriesMobile.js.map